import * as Lucide from "lucide-react";

// Renders any lucide-react icon by name. Falls back to a dot.
export function Icon({ name, className = "", strokeWidth = 1.5, ...rest }) {
  const Cmp = (name && Lucide[name]) || Lucide.Sparkle;
  return <Cmp className={className} strokeWidth={strokeWidth} {...rest} />;
}

export const ICON_CHOICES = [
  "Mic", "BookOpen", "BookText", "Music", "Music2", "Sparkles", "Drama",
  "ShieldCheck", "GraduationCap", "Palette", "Sprout", "Trophy", "Feather",
  "Star", "Heart", "Award", "Users", "Calendar", "MapPin", "Phone", "Mail",
  "Facebook", "Instagram", "Youtube", "Twitter", "Linkedin", "MessageCircle",
  "Quote", "Pen", "Theater", "Languages",
];
